











import { defineComponent } from "@vue/composition-api";
import { Transaction } from "@scrile/api-provider/dist/api/TransactionProvider";
import { $t } from "@/lib/i18nHelpers";
import { getCost } from "@/lib/moneyHelpers";
import FormatMoney from "@/components/FormatMoney";
import TransactionView from "../TransactionView.vue";

export default defineComponent({
  name: "TransactionSubscription",
  components: { FormatMoney, TransactionView },
  props: {
    transaction: { type: Object as () => Transaction, required: true },
  },
  computed: {
    opponentName(): string {
      return this.transaction.details.opponent?.screenName ?? $t("User deleted");
    },
    subscriptionAmount(): number {
      if (!this.transaction.details?.level?.pricePackage) return 0;
      return getCost(this.transaction.details.level.pricePackage);
    },
  },
});
